export enum AnimState {
  Hidden = 'Hidden',
  Enter = 'Enter',
  Entering = 'Entering',
  In = 'In',
  Exit = 'Exit',
  Exiting = 'Exiting',
}
